import React from 'react';

import { Button } from '../../components/Button/Button';
import { useInView } from '../../hooks/useInView';
import type { Hero } from './slides';

import './HeroSection.css';

type HeroSectionProps = {
    data: Hero;
    nav?: React.ReactNode;
};

export function HeroSection({ data, nav }: HeroSectionProps) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="fb-hero">
            <div className="fb-hero__viewport">
                {data.backgroundImage && (
                    <>
                        <img className="fb-hero__bg" src={data.backgroundImage} alt="" aria-hidden="true" />
                        <div className="fb-hero__overlay" aria-hidden="true" />
                    </>
                )}
                {nav && <div className="fb-hero__nav">{nav}</div>}
                <div
                    ref={ref}
                    className={`fb-hero__content${inView ? ' fb-hero__content--in-view' : ''}`}
                >
                    <div className="fb-hero__copy">
                        <div className="fb-hero__text">
                            <h1 className="fb-hero__heading faves-display">{data.heading}</h1>
                            <p className="fb-hero__subhead faves-eyebrow--uppercase">{data.subhead}</p>
                        </div>
                        <Button
                            label={data.cta.label}
                            href={data.cta.href}
                            variant="accent"
                            className="fb-hero__cta"
                        />
                    </div>
                    {data.stats && data.stats.length > 0 && (
                        <ul className="fb-hero__stats">
                            {data.stats.map((stat, i) => (
                                <li className="fb-hero__stat" key={i}>
                                    <span className="fb-hero__stat-value">{stat.value}</span>
                                    <span className="fb-hero__stat-label">{stat.label}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </section>
    );
}
